import FilterlyLogoSvg from "@components/FilterlyLogoSvg"
import RadioCardListPage from "@components/RadioCardListPage"
import { addGenderToLocalStorage } from "@helpers/localStorage"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

const OPTIONS = [
  { emoji: "👩", key: "female" },
  { emoji: "👨", key: "male" },
]

export default function GenderPage() {
  const { t } = useTranslation()

  const handleBeforeSubmit = (value: string) => {
    addGenderToLocalStorage(value.toLowerCase().includes("female"))
  }

  return (
    <RadioCardListPage
      translationKey="gender"
      options={OPTIONS}
      subtitle="subtitle"
      onBeforeSubmit={handleBeforeSubmit}
      header={
        <div className="flex items-center justify-between">
          <FilterlyLogoSvg />

          <Link className="text-lg hover:opacity-80" to="/account/sign-in">
            {t("shared.signIn")}
          </Link>
        </div>
      }
    />
  )
}
